<template>
  	<div class="top-container">
  		<div class="top-ranking">
  			<a href="javascript:;" @click="$emit('changePage', 4)">
  				<img src="../../../assets/img/top-img-ranking.png"><span>排行榜</span>
  			</a>
  		</div>
  		<div class="score-table">
  			<div class="score-tables">
  				<div class="score-title"><img src="../../../assets/img/bcdf.png" class="score-title-img"/></div>
  				<div class="score-number">{{score}}<span>分</span></div>
  				<div class="scroe-highest">最高得分：{{maxScore}}</div>
  				<div class="scroe-btn"><a href="javascript:;" @click="$emit('changePage', 1)">继续挑战</a></div>
  				<div class="scroe-answer">本题正确答案为：<span>{{trueAnswer}}</span></div>
  			</div>
  		</div>
 
  	</div>
</template>

<script>
  import {ApiGetResult} from '../../../net/cdjs/index.js'
  export default {
    data: function () {
      return {
        score: 0,
        maxScore: 0,
        trueAnswer: ''
      }
    },
    props: ['resultId'],
    methods: {
      getReult: function () {
        const pramas = {
          resultId: this.$props.resultId
        }
        ApiGetResult(pramas).then(res=>{
          console.log('res', res)
          if (res.code == 200) {
            this.score = res.value.score
            this.maxScore = res.value.maxScore
            this.trueAnswer = res.value.trueAnswer
          }
        })
      }
    },
    mounted: function () {
      this.getReult()
    }
  }
</script>

<style scoped>
	.top-container{
    background-image: url(../../../assets/img/top1bgimg.jpg);
    background-repeat: no-repeat;
    background-size: 375px 680px;
    width: 375px;
    height: 680px;
    overflow: hidden;
    margin:0 auto;
  }
  .top-ranking{
    float: right;
    margin-top:20px;
  }
  .top-ranking a{
    background:#F64522;
    text-decoration: none;
    float: right;
    height: 20px;
    padding: 10px 4px;
    padding-left: 20px;
    border-radius: 30px 0 0 30px;

  }
  .top-ranking a:hover{
    background:#F64522;
    opacity: 0.9;
  }
  .top-ranking a img{
    width: 20px;
    height: 20px;
  }
  .top-ranking a span{
    font-size: 14px;
    color: #fff;
    font-weight: 600;
    line-height: 20px;
    float: right;
    margin-right: 10px;
  }
  .score-table{
    width: 340px;
    margin:0 auto;
    height: 350px;
    border-radius: 16px;
    margin-top: 280px;
    background-color: rgba(246,192,0,0.3);
    overflow: hidden;
  }
  .score-tables{
    margin: 0 auto;
    text-align: center;
    margin:20px;
    width: 300px;
    height: 310px;
    background: rgba(255,255,255,0.9);
    border-radius: 10px;
  }
  .score-title{
    width: 200px;
    margin: 0 auto;
    margin-top: -21px;
    position: absolute;
    margin-left: 50px;
  }
  .score-title-img{
    width: 200px;
  }
  .score-number{
    color:#E50012;
    font-size: 60px;
    font-weight: 600;
    padding-top: 30px;
    text-align: center;
  }
  .score-number span{
    font-size: 16px;
    color: #999999;
    font-weight: 400;
    margin-left: 10px;
  }
  .scroe-highest{
    font-size: 14px;
    color: #999999;
    margin-top: 15px;
  }
  .scroe-btn{
    width: 200px;
    height: 40px;
    margin:0 auto;
    overflow: hidden;
    margin-top: 35px;
  }
  .scroe-btn a{
    width: 200px;
    height: 40px;
    background: linear-gradient(to right,#F01A15, #FE7832);
    border-radius: 28px;
    text-align: center;
    float: left;
    font-size: 16px;
    line-height: 40px;
    text-decoration: none;
    color: #fff;
  }
  .scroe-btn a:hover{
    opacity: 0.85;
  }
  .scroe-answer{
    font-size: 14px;
    font-weight: 600;
    margin: 0 auto;
    margin-top: 30px;
  }
  .scroe-answer span{
    color:#14AD36;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cdjs/children/score.vue